import BrandTermsAtCheckoutPage from "@faire/prototype-playground/workspace/ym/brand-terms-checkout";
import ConfigurableWidgetMobileSalesChannelsPage from "@faire/prototype-playground/workspace/ym/configurable-widget-mobile-channels";
import ConfigurableWidgetMobileExclusivePage from "@faire/prototype-playground/workspace/ym/configurable-widget-mobile-exclusive";
import FaireDirectConnectTradeShowToolsPage from "@faire/prototype-playground/workspace/ym/faire-direct-connect-trade-show-tools";
import { Route, Switch } from "react-router-dom";

export function YukiMoRoutes() {
  return (
    <Switch>
      <Route
        path="/ym/brand-terms-checkout"
        component={BrandTermsAtCheckoutPage}
      />
      <Route
        path="/ym/configurable-widget-mobile-channels"
        component={ConfigurableWidgetMobileSalesChannelsPage}
      />
      <Route
        path="/ym/configurable-widget-mobile-exclusive"
        component={ConfigurableWidgetMobileExclusivePage}
      />
      <Route
        path="/ym/faire-direct-connect-trade-show-tools"
        component={FaireDirectConnectTradeShowToolsPage}
      />
    </Switch>
  );
}

export const slug = "ym";
